import { useState, Key, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISaleSoFields, IDetailList } from "./bmsBillSaleSoType"
import { saleSoService } from "./bmsBillSaleSoService"
import { formatNum } from "@/utils/utils";
import moment from "moment";
import { useBmsSaleRoDetailModel } from "../bmsBillSaleRo/bmsBillSaleRoModel"

export type ISaleSoDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    discountAll: number,
    receivableAll: number,
    [key: string]: any
}

export const useBmsSaleSoDetailModel = createModel(function () {
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        totalAll: 0,//总计
        discountAll: 0,//折扣,
        receivableAll: 0 //应收
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<ISaleSoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISaleSoDescType>(initDesc)
    const { getBmsTreeNodeName } = useBmsSaleRoDetailModel()

    //设置底部总数展示（查看|编辑|查看）
    useEffect(() => {
        let newDesc: ISaleSoDescType = { ...initDesc };
        detailLookList && detailLookList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.totalAll += Number(item.notAmount);
            newDesc.discountAll += Number(item.notAmount) - Number(item.amount)
            newDesc.receivableAll += Number(item.amount)
        });
        if ("favorableAmount" in detailLookForm) {
            newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount);
            newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount)
        }
        newDesc.itemNumAll = detailLookList && detailLookList.length
        setLookDesc(newDesc);
    }, [detailLookList, detailLookForm])
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await saleSoService.one(id);
        if (retData) {
            const { details, settleDetails, saleTime, ...from } = retData
            const newDetails = details?.map((item) => {
                return {
                    ...item,
                    notAmount: +formatNum(Number(item.num) * Number(item.price)),
                    unitName: getBmsTreeNodeName(item.unitCode as string)
                }
            })
            let newFrom = {
                ...from,
                saleTime: saleTime ? moment(saleTime) : null,
                siteInformationName: getBmsTreeNodeName(from.siteInformation as string),
                maintenanceTypeName: getBmsTreeNodeName(from.maintenanceTypeCode as string),
                settlementPartyName: getBmsTreeNodeName(from.settlementPartyCode as string),
                payType: getBmsTreeNodeName(from.payType as string),
                vehicleTypeName: getBmsTreeNodeName(from.vehicleTypeCode as string),
                customerTypeName: getBmsTreeNodeName(from.customerTypeCode as string),
                invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
                // status: getBmsTreeNodeName(from.status as string)
            }
            setDetailLookForm(newFrom);
            setDetailLookList(newDetails as IDetailList[] ?? [])
        }

    }
    //关闭页签清不同状态缓存
    const resetLookCatch = async (type?: string) => {
        setDetailLookForm({});
        setDetailLookList([]);
    }
    return {
        initPgCfg,
        detailLookForm,
        detailLookList,
        lookDesc,
        setDetailLookForm,
        setDetailLookList,
        setLookDesc,
        getDetailEditOne,
        resetLookCatch,
    }
});